import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'vb-widgets-general-19',
  templateUrl: './19.component.html',
  styleUrls: ['./19.component.scss'],
})
export class VbGeneral19Component implements OnInit {
  constructor() {}
  ngOnInit() {}
}
